import React from 'react';
import { Box } from '@clariness/clarikit-react';

export const NavBarDivider: React.FC = () => {
  return (
    <Box
      width="1px"
      height="30px"
      backgroundColor="color-gray-variant-4"
      aria-hidden="true"
    />
  );
};
